// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Lgtc","inner":"Form_inner__2-a7S","range":"Form_range__-4aw4","name":"Form_name__zhKdE","actions":"Form_actions__21Fmt"};